import { useState } from "react";
import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import {
  Toolbar,
  Box,
  CssBaseline,
  Tabs,
  Tab
} from "@mui/material";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import Logo from "../../assets/logo.png";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${1}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${1}px)`,
    marginLeft: `${1}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const menuItems = [
  { id: '/rentmember/company/ProgrameIntro', label: '프로그램소개' },
  { id: '/rentmember/company/MemberJoin', label: '회원가입' },
  { id: '/rentmember/company/MemberPrice', label: '가격정책' },
  { id: '/rentmember/company/Contact', label: '고객지원' },
];

const RentMember = (props) => {
  const [open, setOpen] = useState(isMobile ? false : true);
  const location = useLocation(); 
  const navigate = useNavigate();

  const home = () => {
    if (location.pathname === "/RentMain/business/BusniessDashboradMobile") return;
    setOpen(false);
    // navigate("/RentMember");    
    // navigate("/RentMain");    
    navigate("/");
  }  

  const handleClick = (path, value) => {    
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const currentTabIndex = menuItems.findIndex(item => location.pathname.startsWith(item.id));

  return (
    <Box
      className="PosMain.css"
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#F9F9F9",
      }}
    >
      <CssBaseline />
      <AppBar
        id="appbar"
        position="fixed"
        color="inherit"
        elevation={1}
      >
        <Toolbar 
          sx={{ 
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}> 
            <img 
              src={Logo} alt="Berry" 
              height="42" 
              onClick={home} 
              style={{
                paddingTop: "6px",
                paddingLeft: "10px",                
                color:"black",
                cursor:"pointer"
              }} 
            />
          </div>

          <Tabs
            value={currentTabIndex >= 0 ? currentTabIndex : false}
            onChange={(e, newValue) => handleClick(menuItems[newValue].id, newValue)}
            textColor="black"
            indicatorColor="primary"
            sx={{ marginLeft: '20px', minHeight: '48px' }}
          >
            {menuItems.map((item, index) => (
              <Tab
                key={item.id}
                label={item.label}
                sx={{
                  fontSize: '15px',
                  textTransform: 'none',
                  minHeight: '48px',
                  // padding: '6px 16px',
                  color:'black',
                  // fontWeight: location.pathname.startsWith(item.id) ? 'bold' : 'normal',
                  // fontWeight: location.pathname.startsWith(item.id) ? 'bold' : 'bold',  
                  fontWeight: "bold",  
                }}
              />
            ))}
          </Tabs>
        </Toolbar>
      </AppBar>

      <Main open={open} 
        sx={{ mt: 8, pb: 0, pl: "10px", pr: "10px", pt: isMobile ? "0px" : "15px" }}
      >
        <Outlet />
      </Main>
    </Box>
  );
};

export default RentMember;
